import React from "react";

const SliderIndicatorIcon = ({
  size = 12,
  color = "#009688",
  active = false,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="6"
      cy="6"
      r={active ? 6 : 5.5}
      fill={active ? color : "none"}
      stroke={active ? "none" : color}
    />
  </svg>
);

export default SliderIndicatorIcon;
